export default __webpack_public_path__ + "static/media/GroovyGravity_07.fd074423.png";